const getDefaultState = () => {
  return {
    page_name: '',
    page_name_parent: '',
  }
}

const state = getDefaultState()

const mutations = {
  SET_PAGE_NAME: (state, page_name) => {
    state.page_name = page_name
  },
  SET_PAGE_NAME_PARENT: (state, page_name_parent) => {
    state.page_name_parent = page_name_parent
  }
}

const actions = {
  setPageName({ commit }, data) {
    commit('SET_PAGE_NAME', data)
  },
  setPageNameParent({ commit }, data) {
    commit('SET_PAGE_NAME_PARENT', data)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
